import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "../firebase";

// Your web app's Firebase configuration VAPID key
const vapidKey = "BBoNGvjJ0Z-C2-u8w-SU4MwVtbMscMCjlxvXWF4ggecLEa678d-Ex_1mRZkHW9ZO9SOAMuQil1y0M_Ma2UDLAr4";


export const requestNotificationPermission = async () => {
  try {
    console.log('Requesting notification permission...');
    
    // Check if service worker is supported
    if (!('serviceWorker' in navigator)) {
      console.log('Service Worker not supported');
      return null;
    }

    // Check if notifications are supported
    if (!('Notification' in window)) {
      console.log('Notifications not supported');
      return null;
    }

    // Register service worker if not already registered
    const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
    console.log('Service Worker registered:', registration);

    // Check current permission status
    let permission = Notification.permission;
    console.log('Current permission status:', permission);

    // Always request permission if not granted
    if (permission === 'default' || permission === 'denied') {
      console.log('Requesting notification permission...');
      permission = await Notification.requestPermission();
      console.log('Permission request result:', permission);
    }
    
    if (permission === 'granted') {
      console.log('Notification permission granted.');
      
      // Wait for service worker to be ready
      await navigator.serviceWorker.ready;
      console.log('Service worker is ready');
      
      // Get registration token
      const token = await getToken(messaging, {
        vapidKey: vapidKey,
        serviceWorkerRegistration: registration
      });
      
      if (token) {
        console.log('Registration token:', token);
        return token;
      } else {
        console.log('No registration token available.');
        return null;
      }
    } else if (permission === 'denied') {
      console.log('Notification permission denied by user.');
      // Show helpful message to user
      alert('To receive notifications, please enable notifications for this site in your browser settings and refresh the page.');
      return null;
    } else if (permission === 'denied') {
      console.log('Notification permission denied by user.');
      // Show helpful message to user
      alert('To receive notifications, please enable notifications for this site in your browser settings and refresh the page.');
      return null;
    } else {
      console.log('Notification permission not granted.');
      return null;
    }
  } catch (error) {
    console.error('An error occurred while retrieving token:', error);
    return null;
  }
};

export const setupForegroundMessageListener = () => {
  onMessage(messaging, (payload) => {
    console.log('Message received in foreground:', payload);
      localStorage.setItem('firebase-messaging-no', JSON.stringify(payload));

    
    // Extract notification data from both notification and data fields
    const notificationTitle = payload.notification?.title || payload.data?.title || 'Default Title';
    const notificationBody = payload.notification?.body || payload.data?.body || 'Default message';
    const notificationIcon = payload.notification?.icon || '/aahera-logo192.png';
    
    console.log('Extracted notification data:', { notificationTitle, notificationBody });
    
    // Show notification when app is in foreground
    if (Notification.permission === 'granted') {
      const notification = new Notification(notificationTitle, {
        body: notificationBody,
        icon: notificationIcon,
        badge: notificationIcon,
        requireInteraction: true,
        silent: false
      });
      
      notification.onclick = function() {
        window.focus();
        notification.close();
      };
    }
  });
};